import { advancedFormControl, FormControlTypeEnum } from '@magieno/common';
import { translationBaseKey } from '../../../decorators/translation-base-key.decorator';
import { CalculationRunOptions } from '../calculation-run.options';
import { CalculationKeynameEnum } from '../../../enums/calculations/calculation-keyname.enum';
import { FieldTypeEnum } from '../../../enums/field-type.enum';
import { IsInt, IsNotEmpty, IsNumber, Min } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../../../builders/error-message.builder';

@translationBaseKey('qpppension-options')
export class QppPensionOptions extends CalculationRunOptions {
  @advancedFormControl({
    type: FormControlTypeEnum.Hidden,
  })
  calculationKeyname: CalculationKeynameEnum = CalculationKeynameEnum.QppPension;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Salaire',
        en: 'Employment income',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  employmentIncome: number;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Age actuel',
        en: 'Current age',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.Number,
    type: FormControlTypeEnum.Input,
  })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  currentAge: number;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Âge au moment du décès',
        en: 'Death Age',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.Number,
    type: FormControlTypeEnum.Input,
  })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  deathAge: number;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Âge de demande de la rente RRQ',
        en: 'Age of application for QPP',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.Number,
    type: FormControlTypeEnum.Input,
  })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  qPPApplicationAge: number;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Taux d\'augmentation de la rente RRQ',
        en: 'Increasing rate for QPP Pension',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.Number,
    type: FormControlTypeEnum.Input,
  })
  @IsNumber(undefined, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @Min(0, { buildErrorMessage: ErrorMessageBuilder.build })
  qPPIncreasingRate: number;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Taux de rendement annuel après impôt',
        en: 'Annual investment rate after taxes',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.Number,
    type: FormControlTypeEnum.Input,
  })
  @IsNumber(undefined, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @Min(0, { buildErrorMessage: ErrorMessageBuilder.build })
  investmentRate: number;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Année fiscale',
        en: 'Fiscal year',
      },
      tooltip: {
        fr: 'Cette propriété spécifie l\'année fiscale à laquelle s\'appliquent les calculs de la rente RRQ. Elle garantit que le logiciel de taxe effectue les calculs en fonction des taux d\'imposition et des règles applicables pour cette année fiscale spécifique.',
        en: 'The \'year\' property specifies the fiscal year to which the QPP pension calculations apply. It ensures that the tax software computes the contributions based on the tax rates and rules applicable for that specific fiscal year.',
      },
    },
    fieldType: FieldTypeEnum.Number,
    type: FormControlTypeEnum.Input,
  })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  fiscalYear: number;
}
